import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LoadingButton from '@mui/lab/LoadingButton';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Autocomplete from '@mui/material/Autocomplete';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { TextField, Paper, Modal, Box } from '@mui/material';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { getToken, getUser, getAclMenu } from '../../utils/common';
import logger from '../../utils/logger';

const capitalizeFirst = (str) => {
  const str1 = str.split('_').join(' ');
  return str1.charAt(0).toUpperCase() + str1.slice(1);
};
// Helper functions moved to outer scope for better performance
function handleClickLang(lang) {
  i18next.changeLanguage(lang);
}

// Extract nested ternary operation for better readability
function getSaveButtonHandler(disable, rulesname, description, assign, handledis, postData, t) {
  if (disable) {
    return handledis;
  }

  if (rulesname && description && assign) {
    return postData;
  }

  return () =>
    notification.error({
      message: 'Error',
      description: t('NofillAssigned.1'),
      placement: 'top',
      duration: 5,
    });
}

// TextfieldCustom3 component moved outside parent component
const TextfieldCustom3 = ({
  id = '',
  size = '',
  tittle = '',
  placeholder = '',
  dropdown = [],
  label = '',
  multiline = false,
  disabled = false,
  onChange,
  indexdata = 0,
  namedata = '',
  rule = [],
  disable = false,
  handleIncrementClick,
}) => (
  <Grid item md={size}>
    <Grid container direction={'column'} spacing={0}>
      <Grid item>
        <Typography variant="subtitle2">{tittle}</Typography>
      </Grid>
      <Grid item>
        {dropdown.length === 0 ? (
          <TextField
            fullWidth
            id={id}
            disabled={disabled}
            style={{ paddingBottom: '1vh', paddingTop: '2vh' }}
            multiline={multiline}
            name={id}
            size="small"
            placeholder={placeholder}
            value={rule[indexdata]?.[namedata]}
            onChange={(e) => {
              handleIncrementClick(indexdata, namedata, e.target.value);
            }}
          />
        ) : (
          <Autocomplete
            fullWidth
            size="small"
            disablePortal
            style={{ paddingBottom: '1vh', paddingTop: '2vh' }}
            disabled={disable}
            value={(dropdown || []).find((e) => e[label] === rule[indexdata]?.[namedata])}
            id={id}
            onChange={(event, newValue) => {
              handleIncrementClick(indexdata, namedata, newValue[label]);
            }}
            options={dropdown}
            getOptionLabel={(dropdown) => dropdown?.[label] || ''}
            getOptionSelected={(option, selectedValue) => option[label] === selectedValue[label]}
            renderInput={(params) => <TextField {...params} fullWidth placeholder={capitalizeFirst(id)} />}
          />
        )}
      </Grid>
    </Grid>
  </Grid>
);

TextfieldCustom3.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  tittle: PropTypes.string,
  placeholder: PropTypes.string,
  dropdown: PropTypes.array,
  label: PropTypes.string,
  multiline: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  indexdata: PropTypes.number,
  namedata: PropTypes.string,
  rule: PropTypes.array,
  disable: PropTypes.bool,
  handleIncrementClick: PropTypes.func,
};

// TextfieldCustom2 component moved outside parent component
const TextfieldCustom2 = ({
  id = '',
  size = '',
  tittle = '',
  placeholder = '',
  dropdown = [],
  label = '',
  multiline = false,
  value = '',
  changer,
  disable = false,
}) => (
  <Grid item md={size}>
    <Grid container direction={'column'} spacing={0}>
      <Grid item>
        <Typography variant="subtitle2">{tittle}</Typography>
      </Grid>
      <Grid item>
        {dropdown.length === 0 ? (
          <TextField
            fullWidth
            disabled={disable}
            id={id}
            multiline={multiline}
            name={id}
            size="small"
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
              changer(e.target.value);
            }}
          />
        ) : (
          <Autocomplete
            fullWidth
            size="small"
            key={id}
            disabled={disable}
            placeholder={placeholder}
            disablePortal
            style={{ paddingBottom: '1vh', paddingTop: '2vh' }}
            value={(dropdown || []).find((e) => e[label] === value)}
            id={id}
            onChange={(event, newValue) => {
              changer(newValue[label]);
            }}
            options={dropdown}
            getOptionLabel={(dropdown) => dropdown?.[label] || ''}
            getOptionSelected={(option, selectedValue) => option[label] === selectedValue[label]}
            renderInput={(params) => (
              <TextField key={id} {...params} fullWidth placeholder={value || 'Select the Dataset'} />
            )}
          />
        )}
      </Grid>
    </Grid>
  </Grid>
);

TextfieldCustom2.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  tittle: PropTypes.string,
  placeholder: PropTypes.string,
  dropdown: PropTypes.array,
  label: PropTypes.string,
  multiline: PropTypes.bool,
  value: PropTypes.string,
  changer: PropTypes.func,
  disable: PropTypes.bool,
};

export default function Pekerja(props) {
  const location = useLocation();
  const [acl] = useState(getAclMenu('action'));
  const [rule, setRule] = React.useState([]);
  const [disable, setdisabled] = React.useState(true);
  const [rulesname, setRulesname] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [channel] = React.useState(location?.state?.index.channel);
  const [assign, setassign] = React.useState('');
  const [id] = React.useState(location?.state?.index.id);
  const [user] = React.useState(getUser());
  const [listassign, setlistassign] = React.useState([]);
  const cancelButtonRef = useRef(null);
  const history = useNavigate();

  React.useEffect(() => {
    setRulesname(location?.state?.index.action_name);
    setDescription(location?.state?.index.description);
    setassign(location?.state?.index.assign);
    setRule(location?.state?.index.steps || []);
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const postData = async () => {
    const item = {
      id,
      action_name: rulesname,
      description,
      channel,
      steps: rule,
      assign,
    };
    try {
      setIsLoading(true);
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}action/edit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(item),
      });

      const data = await response.json();
      if (data && data.response_code === 200) {
        notification.success({
          message: 'Success',
          description: t('EditActionPrompt.1'),
          placement: 'top',
          duration: 5,
        });
      } else if (data.error_message === 'Action found in calendar') {
        notification.error({
          message: 'Error',
          description: t('EditActionPrompt.3'),
          placement: 'top',
          duration: 5,
        });
      } else {
        notification.warning({
          message: 'Warning',
          description: t('EditActionPrompt.2'),
          placement: 'top',
          duration: 5,
        });
      }

      setTimeout(() => {
        history('/dashboard/action');
      }, 4000);
    } catch (error) {
      logger.error('Error:', error);
    }
  };

  const hapus = async () => {
    const item = {
      id,
      action_name: rulesname,
      description,
      channel,
      steps: rule,
      assign,
    };

    try {
      setIsLoading(true);
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}action/delete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(item),
      });

      const data = await response.json();
      if (data && data.response_code === 200) {
        notification.success({
          message: t('DeleteActionPrompt.1'),
          placement: 'top',
          duration: 5,
        });
      } else if (data.error_message === 'Action found in calendar') {
        notification.error({
          message: 'Error',
          description: t('DeleteActionPrompt.3'),
          placement: 'top',
          duration: 5,
        });
      } else {
        notification.warning({
          message: 'Warning',
          description: t('DeleteActionPrompt.2'),
          placement: 'top',
          duration: 5,
        });
      }
      handleCloseds();
      setTimeout(() => {
        history('/dashboard/action');
      }, 4000);
    } catch (error) {
      logger.error('Error:', error);
    }
  };

  function handleIncrementClick(index, value, e) {
    const nextCounters = rule.map((c, i) => {
      if (i === index) {
        return { ...c, [value]: e };
      }

      return c;
    });
    setRule(nextCounters);
  }

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(rule);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setRule(items);
  };
  const { t } = useTranslation();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 5,
    p: 4,
  };

  const [disableDrag, setDisableDrag] = useState(true);

  function handledis() {
    setdisabled(!disable);
    setDisableDrag(!disable);
  }
  function handlediscancel() {
    setdisabled(!disable);
    setDisableDrag(!disable);
    window.history.go(-1);
  }

  const handleAddStep = () => {
    const nextStep = rule.length > 0 ? rule.at(-1).step + 1 : 1;
    const newStep = {
      step: nextStep,
      description: '',
    };
    setRule((prevRule) => [...prevRule, newStep]);
  };

  const handleDeleteStep = (stepToDelete) => {
    const filteredRule = rule.filter((item) => item.step !== stepToDelete); // Remove the deleted step from the rule array
    setRule(filteredRule);

    // Ensure unique steps by reassigning step numbers
    const updatedRule = filteredRule.map((item, index) => ({
      ...item,
      step: index + 1,
    }));
    setRule(updatedRule);
  };
  notification.config({
    placement: 'top',
    duration: 5,
  });

  const getKey = (step) => `step-${step.step}`;

  function CardBack() {
    return (
      <Grid container direction={'row'}>
        <Grid item>
          <Link to="/dashboard/action">
            <IconButton style={{ color: '#1EB3D9' }}>
              <ArrowBackIcon />
            </IconButton>
          </Link>
        </Grid>
        <Grid item alignSelf={'center'}>
          <Typography variant="h4"> {t('EditAction.1')}</Typography>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p style={{ fontSize: '16px' }}>
              {t('LastEdited.1')} {user || ''}
            </p>
            {/* <Avatar
                alt="Profile Picture"
                src="././../../../public/assets/images/avatars/avatar_12.jpg"
                style={{ marginLeft: '10px' }}
              /> */}
          </div>
        </Grid>
      </Grid>
    );
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`${globalThis.REACT_APP_API_PURE}actions/listassign`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      const data = await response.json();
      setlistassign(data);
    };
    fetchData();
  }, []);

  const [openeds, setOpeneds] = React.useState(false);
  const handleOpeneds = () => setOpeneds(true);
  const handleCloseds = () => setOpeneds(false);

  const [loading, setLoading] = React.useState(false);
  function handleLoad() {
    hapus();
  }

  return (
    <span>
      <Paper
        style={{
          padding: 20,
          minHeight: '80vh',
          backgroundColor: '#fafafc',
          boxShadow: 'none',
        }}
      >
        <Stack direction="row" justifyContent="space-between" mb={5}>
          {CardBack()}
        </Stack>
        <Stack direction={'row'} spacing={3} className="main">
          <div className="clm-1">
            <p style={{ fontSize: '18px' }}>{t('NameActions.1')}</p>
            <br />
            {TextfieldCustom2({
              id: 'actions_name',
              size: 12,
              tittle: '',
              placeholder: 'Investigate Data Integrity Breach',
              value: rulesname,
              changer: setRulesname,
              dropdown: '',
              disable,
            })}
          </div>
          <div className="clm-2" style={{ flex: 1 }}>
            <p style={{ fontSize: '18px' }}>{t('Deskripsyong.1')}</p>
            <br />
            {TextfieldCustom2({
              id: 'description',
              size: 12,
              tittle: '',
              multiline: true,
              value: description,
              changer: setDescription,
              dropdown: '',
              disable,
            })}
          </div>
        </Stack>
        <div className="clm-1" style={{ flex: 1, paddingTop: '2vh' }}>
          <p style={{ fontSize: '18px' }}>{t('AssignDataset.1')}</p>
          {TextfieldCustom2({
            id: 'assign',
            size: 4,
            tittle: '',
            dropdown: listassign,
            label: 'id',
            value: assign || 'Empty Dataset',
            changer: setassign,
            disable,
          })}
        </div>
        <Grid container direction={'row'} spacing={2} style={{ justifyContent: 'space-between' }}>
          <Grid item xs={12}>
            <Paper style={{ padding: 10 }}>
              <Grid xs={12} container direction={'column'} spacing={1}>
                <Grid item container direction={'row'}>
                  {' '}
                </Grid>
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Paper style={{ padding: 10 }}>
                    <Droppable droppableId="droppable">
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          {rule.map((item, index) => (
                            <Draggable
                              isDragDisabled={disableDrag}
                              key={getKey(item)}
                              draggableId={item.step.toString()}
                              index={index}
                            >
                              {(provided) => (
                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                  <TextfieldCustom3
                                    id="description"
                                    size={12}
                                    tittle={t('Deskripsyong.2')}
                                    label="id"
                                    indexdata={index}
                                    namedata="description"
                                    multiline
                                    disabled={disable}
                                    dropdown=""
                                    rule={rule}
                                    disable={disable}
                                    handleIncrementClick={handleIncrementClick}
                                  />
                                  <Grid item xs>
                                    {''}
                                  </Grid>
                                  <Grid style={{ paddingBottom: '2vh' }} item>
                                    {acl?.delete && rule.length > 1 ? (
                                      <Button
                                        className={` ${disable ? 'opacity-80 cursor-not-allowed' : ''}`}
                                        disabled={disable}
                                        key={item.step}
                                        variant="contained"
                                        // endIcon={<AddIcon />}
                                        style={{
                                          textTransform: 'none',
                                          backgroundColor: disable ? 'gray' : 'red',
                                          color: 'white',
                                        }}
                                        onClick={handleDeleteStep.bind(null, item.step)}
                                      >
                                        {t('DeleteStep.1')}
                                      </Button>
                                    ) : null}
                                  </Grid>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </Paper>
                </DragDropContext>
              </Grid>
            </Paper>
          </Grid>
          <Modal
            open={openeds}
            onClose={handleCloseds}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Typography as="h3" className="text-base font-semibold leading-6 text-gray-900">
                      {t('DeleteButton.1')}
                    </Typography>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">{t('PromptDelete.1')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <LoadingButton
                  type="button"
                  loading={loading}
                  loadingPosition="start"
                  className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  onClick={() => {
                    handleLoad();
                    setLoading(true);
                  }}
                >
                  {t('DeleteAction.1')}
                </LoadingButton>
                <button
                  type="button"
                  className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => setOpeneds(false)}
                  ref={cancelButtonRef}
                >
                  {t('CancelButton.1')}
                </button>
              </div>
            </Box>
          </Modal>
          <Grid item xs={12}>
            <div style={{ paddingTop: '15px' }}>
              <Button variant="outlined" disabled={disable} fullWidth startIcon={<AddIcon />} onClick={handleAddStep}>
                {t('AddStep.1')}
              </Button>
            </div>
          </Grid>
          <Grid
            item
            container
            direction={'row'}
            style={{ textAlignLast: 'right', placeContent: 'flex-end' }}
            spacing={2}
          >
            {acl?.delete && (
              <Grid item>
                <LoadingButton
                  variant="contained"
                  // endIcon={<AddIcon />}
                  disabled={isLoading}
                  style={{
                    textTransform: 'none',
                    backgroundColor: isLoading ? 'gray' : 'red',
                    color: 'white',
                  }}
                  onClick={disable ? handleOpeneds : handlediscancel}
                >
                  {disable ? t('DeleteAction.1') : t('CancelButton.1')}
                </LoadingButton>
              </Grid>
            )}
            {acl?.update && (
              <Grid item>
                <LoadingButton
                  variant="contained"
                  // endIcon={<AddIcon />}
                  style={{
                    textTransform: 'none',
                    backgroundColor: isLoading ? 'gray' : 'green',
                    color: 'white',
                  }}
                  loading={isLoading}
                  disabled={isLoading}
                  loadingPosition="start"
                  onClick={getSaveButtonHandler(disable, rulesname, description, assign, handledis, postData, t)}
                >
                  {disable ? t('EditAction.1') : t('SubmitButton.1')}
                </LoadingButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Paper>
    </span>
  );
}

Pekerja.propTypes = {
  listnamapegawai: PropTypes.array,
  data: PropTypes.shape({
    error_message: PropTypes.string,
    response_code: PropTypes.number,
  }),
  isdialog: PropTypes.bool,
  closedialog: PropTypes.func,
};
